import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CONFIRM_ORDER: "Bekreft endring",
      STANDALONE_PRODUCTS: "Dagligvarer",
      CHANGE_STANDALONE_PRODUCTS_LINK_TEXT: "Endre dagligvarer",

      YOU_HAVE_NOT_ADDED_ANY_ADDONS_TO_YOUR_SUBSCRIPTION:
        "Du har ikke lagt til noen dagligvarer å abonnere på.",
      ADD_ADDONS_BUTTON_TEXT: "Legg til dagligvarer",

      ENJOY_YOUR_MEAL: "Velbekomme!",
      DETAILED_OVERVIEW: "Detaljert oversikt",
      FORMAT_ADDON_COUNT: (count: number) =>
        count === 1 ? `${count} dagligvare` : `${count} dagligvarer`,
      TOTAL: "Totalt",
      DISCLAIMER: "Ved at godkjenne aksepterer jeg",
      TOS_LINK_TEXT: "leveringsbetingelsene",

      ACTION_BAR_CONFIRM_BUTTON: "Bekreft",
      ACTION_BAR_TOTAL: "Totalt",

      GENERIC_ERROR_MESSAGE: "Noe gikk galt, kontakt support",
    },

    se: {
      CONFIRM_ORDER: "Bekräfta ändring",
      STANDALONE_PRODUCTS: "Livsmedel",
      CHANGE_STANDALONE_PRODUCTS_LINK_TEXT: "Ändra livsmedel",

      YOU_HAVE_NOT_ADDED_ANY_ADDONS_TO_YOUR_SUBSCRIPTION:
        "Du har inte lagt till något livsmedel att prenumerera på.",
      ADD_ADDONS_BUTTON_TEXT: "Lägg till livsmedel",

      ENJOY_YOUR_MEAL: "Smaklig måltid!",
      DETAILED_OVERVIEW: "Detaljerad översikt",
      FORMAT_ADDON_COUNT: (count: number) => `${count} livsmedel`,
      TOTAL: "Totalt",
      DISCLAIMER: "Genom att starta bekräftar jag",
      TOS_LINK_TEXT: "leveransvillkoren",

      ACTION_BAR_CONFIRM_BUTTON: "Bekräfta",
      ACTION_BAR_TOTAL: "Totalt",

      GENERIC_ERROR_MESSAGE: "Något gick fel, försök igen senare",
    },

    dk: {
      CONFIRM_ORDER: "Bekræft ændring",
      STANDALONE_PRODUCTS: "Specialvarer",
      CHANGE_STANDALONE_PRODUCTS_LINK_TEXT: "Skift specialvarer",

      YOU_HAVE_NOT_ADDED_ANY_ADDONS_TO_YOUR_SUBSCRIPTION:
        "Du har ikke tilføjet nogen specialvare at abonnere på.",
      ADD_ADDONS_BUTTON_TEXT: "Tilføj specialvarer",

      ENJOY_YOUR_MEAL: "Velbekomme!",
      DETAILED_OVERVIEW: "Detaljeret oversigt",
      FORMAT_ADDON_COUNT: (count: number) =>
        count === 1 ? `${count} specialvare` : `${count} specialvarer`,
      TOTAL: "I alt",
      DISCLAIMER: "Ved at godkende accepterer jeg",
      TOS_LINK_TEXT: "leveringsbetingelsene",

      ACTION_BAR_CONFIRM_BUTTON: "Godkend",
      ACTION_BAR_TOTAL: "I alt",

      GENERIC_ERROR_MESSAGE: "Noget gik galt, kontakt support",
    },
  } as const
)[language];
